module.exports = __webpack_public_path__ + "h5/img/live-logo.12159eb3.gif";